import { defineStore } from 'pinia';

import {
  TerminalDetailResponse,
  TerminalRepository,
} from '@/repositories/generated';
import { TerminalEditForm } from '@/validations';

type TEditTerminalState = {
  form: TerminalEditForm | undefined;
  initData: TerminalDetailResponse | undefined;
};

export const useEditTerminalStore = defineStore('editTerminal', {
  state: (): TEditTerminalState => ({
    form: undefined,
    initData: undefined,
  }),
  actions: {
    async editTerminal() {
      const {
        form,
        initData,
      } = this;

      if (!(form && initData)) return;

      await TerminalRepository.edit({
        id: initData.id,
        requestBody: {
          ...form,
          shopId: form.shopId ?? '', // TODO: 店舗IDを編集可能にする際に修正する
          externalId: form.externalId ?? '', // TODO: 端末編集で外部端末IDをnullableにする際に修正する(REM-2317)
          startsAt: form.startsAt.toISOString(),
          endsAt: form.endsAt?.toISOString(),
          terminalStickerId: form.terminalStickerId || undefined, // terminalStickerIdが空文字の場合にundefinedにしたいため||を使用
          lastUpdatedAt: form.lastUpdatedAt,
          terminalPassword: form.canEditTerminalPassword
            ? (form.terminalPassword ?? initData.terminalDetailBasicInfo.terminalPassword)
            : '',
        },
      });
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await TerminalRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: TerminalEditForm) {
      const createForm = (_form: TerminalEditForm) => ({
        ..._form,
      });
      this.form = createForm(form);
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
